<template>
	<modal
		ref="sessionExpiredModal"
		title="Session Expired"
		:disable-close="true">
		<template #body>
			Your session has expired, please refresh the page to continue.
		</template>
	</modal>
</template>

<script>
	import Modal from '@js/components/Modal.vue';
	import {getLastSessionRefreshAt, getSessionLifetime} from '@js/utilities/axios.js';
	export default {
		name: 'SessionExpiredModal',
		components: {Modal},
		data() {
			return {
				interval: null,
				session_expires_at: null,
				session_expired: false,
			}
		},
		mounted() {
			this.interval = setInterval(this.checkSession, 1000)
		},
		beforeUnmount() {
			clearInterval(this.interval)
		},
		methods: {
			checkSession() {
				const lifetime = getSessionLifetime();
				if (!Number.isFinite(lifetime) || lifetime <= 0) {
					return;
				}

				this.session_expires_at = moment(getLastSessionRefreshAt()).add(lifetime, 'minutes');

				let diff = moment().diff(this.session_expires_at, 'seconds');

				if (diff > -30) {
					this.$refs.sessionExpiredModal.open();
					this.session_expired = true;
				} else if (this.session_expired) {
					this.$refs.sessionExpiredModal.close();
					this.session_expired = false;
				}
			}
		}
	}
</script>

<style scoped>

</style>
